import { filterConstants } from '../utils/types';
import { parseFilters } from '../utils/other';
import ApiClient from '../utils/apiClient';

export default function setFilter(filterName, value) {
  return {
    type: filterConstants.SET_FILTER,
    filterName,
    value
  };
}

export function setCourtsFilters(courtsFilters) {
  return {
    type: filterConstants.SET_COURTS_FILTERS,
    payload: {
      courtsFilters
    }
  };
}

export function initCourtFilters() {
  return (dispatch, getState) => {
    const state = getState();
    if (state.filter.courtsFilters && state.filter.courtsFilters.length === 0) {
      return ApiClient.get('/api/v1/courts-filter/')
        .then(response => {
          const filters = response.data;
          dispatch(setCourtsFilters(parseFilters(filters)));
        })
        .catch(error => {
          throw error;
        });
    }
    return 0;
  };
}



// WEBPACK FOOTER //
// ./src/actions/filterActions.js